import { twMerge } from 'tailwind-merge';

import { TableBodyCell } from './TableBodyCell';

export const TableCellDate = ({
  date,
  time,
  className,
  withBorderBottom,
  isPast = false,
}) => {
  const isDateTimeVisible = !!date && !!time;
  const textClassName = twMerge(
    'truncate font-medium text-[16px]/[24px]',
    className,
    isPast ? 'text-destructive-500' : 'text-base-1000',
  );

  return (
    <TableBodyCell withBorderBottom={withBorderBottom}>
      <div className="flex flex-col truncate">
        {isDateTimeVisible ? (
          <>
            <span className={textClassName}>{date}</span>
            <span className={textClassName}>{time}</span>
          </>
        ) : (
          <span className={textClassName}>-</span>
        )}
      </div>
    </TableBodyCell>
  );
};
